<template>
  <div v-if="getPermission.do.view || getPermission.doReadOnly.view">
    <do-item-form ref="DoItemFormChange" mode="updateItem"/>
    <move-load ref="MoveLoad" mode="MOVE" :action="onfresh"/>

    <md-card class="searchPanel">
      <md-card-content v-if="searchRequest">
        <div class="md-layout md-gutter">
          
          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <master-data-select 
              label="Office" 
              group="GST_SALEOFFICE" 
              v-model="searchRequest.salesOffice" disabled
              @keyup.enter="doSearch"/>
            </div>
          </div> -->

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox" >
                <md-field>
                  <label>Office</label>
                  <md-input v-model="searchRequest.salesOffice" disabled @keyup.enter="doSearch"/>
                </md-field>
              </div>
          </div>


          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <master-data-select 
              label="Order Type" 
              group="GST_DELIVERYTYPE" 
              v-model="searchRequest.deliveryType" disabled
              @keyup.enter="doSearch"/>
            </div>
          </div> -->

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox" >
                <md-field>
                  <label>Order Type</label>
                  <md-input v-model="searchRequest.deliveryType" disabled @keyup.enter="doSearch"/>
                </md-field>
              </div>
          </div>

          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <md-field>
              <label>Delivery Order</label>
              <md-input 
              v-model="searchRequest.deliveryOrder" disabled
              @keyup.enter="doSearch"/>
            </md-field>
            </div>
          </div> -->

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox" >
                <md-field>
                  <label>Delivery Order</label>
                  <md-input v-model="searchRequest.deliveryOrder" disabled @keyup.enter="doSearch"/>
                </md-field>
              </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox" >
                <md-field>
                  <label>Customer PO</label>
                  <md-input v-model="searchRequest.customerPO" disabled @keyup.enter="doSearch"/>
                </md-field>
              </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox" >
                <md-field>
                  <label>Booking#</label>
                  <md-input v-model="searchRequest.bookObl" disabled @keyup.enter="doSearch"/>
                </md-field>
              </div>
          </div>

          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <md-field>
              <label>Booking#</label>
              <md-input 
              v-model="searchRequest.bookObl" 
              @keyup.enter="doSearch"/>
            </md-field>
            </div>
          </div> -->

          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-30">
            <div class = "inputBox">
              <md-field>
              <label>Container#</label>
              <md-input 
              v-model="searchRequest.containerNo" 
              @keyup.enter="doSearch"/>
            </md-field>
            </div>
          </div> -->

        </div>  
      </md-card-content>
                  

      <md-card-actions md-alignment="space-between">
        <div>
          <calling-api path="/api/w/gst/loadlist/create">
            <md-button class="md-raised" @click="doChange" :disabled="!getSelectedDoitem && !this.getPermission.stcClerk.view"><span class="icons-center material-icons">update</span>Edit</md-button>
            <md-button class="md-raised md-primary" @click="getMoveLoad()" :disabled="!getSelectedMove && !this.getPermission.stcClerk.view"><span class="icons-center material-icons">create</span>Move Load</md-button>   
          </calling-api>
        </div>
          <div>                        
            <div class= "inputBoxMessage">
              <b-notification
                  type="is-success"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
              </b-notification>
            </div>
          </div> 
        <div>
          
          <!-- <calling-api path="/api/w/fsi/GetIBSOutbound"> -->
          <calling-api path="/api/w/do/doitem">
            <md-button class="md-raised md-primary " @click="doSearch">Refresh</md-button>
            <!-- <md-button class="md-raised custButton" @click="clearSearch">Clear</md-button> -->
          <md-button class="md-icon-button" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
          </calling-api>
        </div>
      </md-card-actions>
      
    </md-card>

    <pagination :items="getDoitemToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                    <th class="header-cell center w2" v-on:click="sortFunction('receivingWindows')">Rec.W</th>
                    <th class="header-cell center w3" v-on:click="sortFunction('loadStatus')">Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load ID</th>
                    <th class="header-cell center w2" v-on:click="sortFunction('source')">Source</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">Container#</th>
                    <th class="header-cell center w3" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w3" v-on:click="sortFunction('ctnrType')">Ctnr Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chassisNo')">Chassis#</th>
                    <th class="header-cell center w3" v-on:click="sortFunction('chassisVendor')">C.Vend</th>
                    <th class="header-cell center w2" v-on:click="sortFunction('ownChassis')">Own</th>
                    <th class="header-cell center w4" v-on:click="sortFunction('moveInDate')">Move In</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('moveInBy')">MoveIn By</th>
                    <th class="header-cell center w2" v-on:click="sortFunction('grade')">Grade</th>
                    <!-- <th class="header-cell center w3">Tare</th>
                    <th class="header-cell center w3">Gross</th>
                    <th class="header-cell center w3">Net</th> -->
                    <!-- <th class="header-cell center w5">outboundDate</th> -->
                    <th class="header-cell center w2">sap</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.seqNo" v-for="item in pageItems" v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2" v-if="item.loadStatus != 'OU' && getPermission.stcClerk.view"><md-checkbox v-model="item.selected"></md-checkbox></td>
                      <td class="body-cell w2" v-if="item.loadStatus == 'OU' || !getPermission.stcClerk.view"></td>
                      <td class="body-cell excelBox w2">{{item.receivingWindows}}</td>
                      <td class="body-cell excelBox w3">{{item.loadStatus}}</td>
                      <td class="body-cell excelBox w5">{{item.seqNo}}</td>
                      <td class="body-cell excelBox w2">{{item.source}}</td>
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                      <td class="body-cell excelBox w3">{{item.carrier}}</td>
                      <td class="body-cell excelBox w3">{{item.ctnrType}}</td>
                      <td class="body-cell excelBox w5">{{item.chassisNo}}</td>
                      <td class="body-cell excelBox w3">{{item.chassisVendor}}</td>
                      <td class="body-cell excelBox w2">{{item.ownChassis}}</td>
                      <td class="body-cell excelBox w4">{{item.moveInDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.moveInBy}}</td>
                      <td class="body-cell excelBox w2">{{item.grade}}</td>
                      <!-- <td class="body-cell excelBox w3">{{item.tareWeight}}</td>
                      <td class="body-cell excelBox w3">{{item.vgmWeight}}</td>
                      <td class="body-cell excelBox w3">{{item.weight}}</td> -->
                      <!-- <td class="body-cell excelBox w5">{{item.outboundDate | date}}</td> -->
                      <td class="body-cell excelBox w2">{{item.sapStatus}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

  .selected.selected {
    background: yellow;
  }

  .cl {
      /* padding-left: 40%;
      padding-right: 40%; */
      margin: 0px;
  }

  .cl .md-field{
      display: inline-block ;
      width: auto;
      margin-bottom: 10px;
      padding-top:10px;
  }

  .cl .md-field .md-input {
      font-size: 14px;
  }

  .inputBoxMessage {
    width: 500px;
    margin: auto;
  }


</style>

<script>
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import api from "../api";
  import parseXls from "../utils/parseXls";
  import validateDate from '../utils/validate-date';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import { sortList } from '../utils/sort';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import DoItemForm from '../components/DoitemForm.vue';
  import MoveLoad from '../components/MoveLoad.vue';
  import sort from 'fast-sort';
  import moment from 'moment';


  const getInitSearch = () => ({
      salesOffice: "LGB",
      deliveryOrder: null,
      deliveryType: null,
      customerPO: null,
      ibd: null,
      bookObl: null,
      containerNo: null,
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      dialog: {
        isShowing: false,
      },
      items:[],
      notifyActive: false,
      notifyMessage: null,
      allItemsSelected: false,
      sortStatus: true,
      active: true,
      filter:"",
      selected: false,
      trimOption: [
        "deliveryOrder",
        "bookObl",
        "customerPO",
        "containerNo",
        "ibd"
        ,
      ],
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
      DoItemForm,
      MoveLoad,
    },

    watch: {
      getDoitem(val) {
       this.updateDoitem(val);
        },
      },

    computed: {
      ...mapGetters([
        'getDoitem',
        'getMasterDataName',
        'getUserProfile',
        'getPermission',
      ]),

      getDoitemToDisplay() {
        // return this.items;
        return _(this.items).sortBy((it) => {it.containerNo}).reverse();
      },

      getSelectedDoitem() {
        const item = _(this.items).filter((it) => it.selected);
        const loadStatus = _(this.items).filter((it) => it.loadStatus != 'OU');
        if (loadStatus.length == 0) return false
          return item.length === 1 && item[0].loadStatus != 'OU' && this.items.filter(it => it.selected)
      },

      getSelectedMove() {
        if ( this.searchRequest.deliveryOrder == "" || this.searchRequest.deliveryOrder == null ) {             
          return false;
        }
        if ( this.$route.params.deleteBit == "X") {             
          return false;
        }
        const loadStatus = _(this.items).filter((it) => it.loadStatus != 'OU');
        if ( this.getSelectedItems.length === 0 ) return false;
        return this.items.filter(it => it.selected)
      },

      getSelectedItems() {
        return _(this.items).filter((it) => it.selected);
      },
     
    },

    
    async mounted() {
      const cachedSearchRequest = this.$store.state.doitem.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      } else {
        this.searchRequest = getInitSearch(this);
      }
      this.updateDoitem(this.getDoitem);

      if (this.$route.params.deliveryOrder != null)
      {
        this.searchRequest = getInitSearch(this);
        this.searchRequest.salesOffice = this.$route.params.salesOffice;
        this.searchRequest.deliveryOrder = this.$route.params.deliveryOrder;
        this.searchRequest.deliveryType = this.$route.params.deliveryType;
        this.searchRequest.customerPO = this.$route.params.customerPO;
        this.searchRequest.bookObl = this.$route.params.bookObl;
        this.doSearch();
      }
    },

    methods: {

      trimTool(ent) {
        return ent == null ? null : ent.trim()
      },

      mouseOver: function(){
        this.active = true;
      },

      mouseLeave: function() {
        this.active = !this.active;
      },

      sortFunction(sortFiled) {
        const sorted = sort(this.items).asc(sortFiled);
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus) {
          this.items = sorted;
        } else {
          this.items = sorted.reverse();
        }
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) });
      },

      updateDoitem(items) {  
        var items = JSON.parse(JSON.stringify(items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },
      
      doSearch() {
        this.items = [];
        this.active = true;
        // if (this.searchRequest.salesOffice == null)
        // {
        //   alert("Sales Office is required filed")
        //   return 
        // }

        for (const el of this.trimOption) {
          this.searchRequest[el] = this.trimTool(this.searchRequest[el]);
        }

        this.$nextTick(() => {
          this.$store.dispatch('loadDoitem', this.searchRequest);
        });
      },

      clearSearch() {
        this.searchRequest = getInitSearch();
        this.items = this.getDoitem;
        this.updateDoitem(this.items);
      },

      doChange() {
        const request = this.getSelectedDoitem[0];
        request.salesOffice = this.searchRequest.salesOffice;
        request.deliveryType = this.searchRequest.deliveryType;
        this.$refs.DoItemFormChange.openDialog(request);
        this.doSearch();
      },


      getMoveLoad() {
        const loads = this.getSelectedItems
        this.$refs.MoveLoad.openDialog(loads);
      },

      handleAllItemSelectedChanged() {
          _(this.items).each(it => {  
          it.selected = this.allItemsSelected;
        })
      },

      async onfresh(oldDeliveryOrder, deliveryOrder,  loads) {
        console.log(`${oldDeliveryOrder} , ${deliveryOrder} , ${loads}`);
        this.notifyActive = true;
        this.notifyMessage =  null;
        this.notifyMessage = `Container/Load: {${loads}} moved from ${oldDeliveryOrder} to ${deliveryOrder}.`;
        this.doSearch();
      },

    },
  };
</script>


